import { FunctionComponent, useCallback, ChangeEvent } from 'react'
import { PriceInput } from '@dxp-module/common'
import { MyAccountWidgetProps } from '../../../model/MyAccountWidgetProps'
import priceInputStyles from './priceInput.styles'

const PriceInputWidget: FunctionComponent<MyAccountWidgetProps> = props => {
  const {
    id,
    value,
    label,
    onChange,
    schema,
    required,
    rawErrors,
    uiSchema,
    disabled,
  } = props
  const {
    maximum,
    exclusiveMaximum,
    minimum,
    exclusiveMinimum,
    default: schemaDefault,
    disabled: schemaDisabled,
  } = schema
  const { showDefaultValue } = uiSchema['ui:options'] || {}
  const styles = priceInputStyles({})

  const hasErrors = rawErrors && rawErrors.length > 0

  const handleChange = useCallback(
    (event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
      onChange(event.target.value)
    },
    [onChange]
  )

  return (
    <PriceInput
      id={id}
      name={id}
      value={showDefaultValue ? schemaDefault : value}
      label={label}
      required={required}
      disabled={disabled || schemaDisabled}
      minValue={exclusiveMinimum || minimum}
      maxValue={exclusiveMaximum || maximum}
      error={hasErrors}
      message={hasErrors ? rawErrors[0] : undefined}
      onChange={handleChange}
      classes={styles}
      data-test={id}
    />
  )
}

export default PriceInputWidget
